import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AsyncReduxState, initialAsyncReduxState } from '../../../redux/@config/AsyncReduxState'

export type ValkTalkPostState = AsyncReduxState

const initialState: ValkTalkPostState = {
    ...initialAsyncReduxState,
}

export const valkTalkPostSlice = createSlice({
    name: 'valkTalkPostReducer',
    initialState,
    reducers: {
        setIsUpdating(state, action: PayloadAction<boolean>): ValkTalkPostState {
            return {
                ...state,
                isUpdating: action.payload,
            }
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): ValkTalkPostState {
            return {
                ...state,
                isSuccessful: action.payload,
            }
        },
        setError(state, action: PayloadAction<string>): ValkTalkPostState {
            return {
                ...state,
                error: action.payload,
            }
        },
    },
})

export const {
    setIsUpdating,
    setIsSuccessful,
    setError,
} = valkTalkPostSlice.actions

export const valkTalkPostReducer = valkTalkPostSlice.reducer
